import { Decimal } from 'decimal.js'

function floorQuantityByScale (quantity, quantityPrecision, quantityTick) {
  let qty = new Decimal(quantity)

  if (qty.decimalPlaces() > quantityPrecision && quantityPrecision > 0) {
    qty = qty.toDP(quantityPrecision, Decimal.ROUND_FLOOR)
  }
  // floor to quantity tick e.g
  // quantity = 15433.233 , quantityTick = 10000 -> scale = -4, quantity = 10000
  // qauntity = 119315 ,quantityTick = 10000 -> scale = -4, quantity = 110000
  // quantity = 9825, qunatityTick = 10000 -> scale = -4,  quantity = 0
  // quantity = 15433.233 quantityTick = 12000 -> scale = -3,  quantity = 15000
  // quantity = 9825, qunatityTick = 12000 -> scale = -3,  quantity = 9000
  let result = qty.toNumber()

  if (quantityPrecision === 0 && quantityTick && quantityTick >= 1) {
    const qtyTick = new Decimal(quantityTick)
    const sd = qtyTick.sd()

    qty = qty.toDP(quantityPrecision, Decimal.ROUND_FLOOR)
    const strQty = qty.toString()
    const scale = qtyTick.toString().length - sd
    // if scale >= quantity string length return 0
    // if scale < quantity string length, return sd of quantity * 10e+(strQty.length - sd)

    if (scale >= strQty.length) {
      return 0
    } else {
      const pow = new Decimal(10).pow(scale)
      const flooredQty = new Decimal([...strQty].slice(0, strQty.length - scale).join('')).mul(pow)

      result = flooredQty.toNumber()
    }
  }

  return result
}
// convert from backend java logic https://crypt0-hq-sz.slack.com/archives/C035KQYNEFJ/p1679476868400329
export function calculateGridBotMinTotalInvestment (lowerPrice, upperPrice, gridNo, minQty, pricePrecision, qtyPrecision, priceTick = 0) {
  const adjustedFees = 0.00175
  const totalInvestmentIncrementer = 1.1

  // console.log('lowerPrice:', lowerPrice, 'upperPrice:', upperPrice, 'gridNo:', gridNo, 'minQty:', minQty, 'pricePrecision:', pricePrecision, 'qtyPrecision:', qtyPrecision, 'priceTick:', priceTick)

  if (gridNo < 2) {
    return [0, gridNo]
  }
  function buildArithmeticLadder (gridNumber) {
    if (upperPrice == null || lowerPrice == null) {
      return null
    }
    if (upperPrice <= lowerPrice) {
      return null
    }

    const ladders = [] as any[]
    const spread = new Decimal(upperPrice).minus(lowerPrice)
      .div(gridNumber)
    let gridLowPrice = lowerPrice

    for (let i = 0; i < gridNumber; i++) {
      let gridHighPrice: any = new Decimal(lowerPrice).add(spread.mul(i + 1))

      if (gridHighPrice.decimalPlaces() > pricePrecision) {
        gridHighPrice = gridHighPrice.toDP(pricePrecision, Decimal.ROUND_FLOOR)
      }
      gridHighPrice = gridHighPrice.toNumber()
      if (i === gridNumber - 1) {
        gridHighPrice = upperPrice
      }
      const level = [] as any[]

      level.push(gridLowPrice)
      level.push(gridHighPrice)
      ladders.push(level)
      gridLowPrice = gridHighPrice
    }

    return ladders
  }
  function isPositiveGridProfit (totalInvestment, gridNumber) {
    if (gridNumber < 1) {
      return false
    }
    const ladder = buildArithmeticLadder(gridNumber)

    if (ladder == null) {
      return false
    }
    const qtyRatioFeesDeducted = 1 - adjustedFees
    let openQuantity = new Decimal(0)
    let openNotional = new Decimal(0)
    let closeQuantity = new Decimal(0)
    let closeNotional = new Decimal(0)
    let closeFee = new Decimal(0)
    let gridProfit = new Decimal(0)

    for (const gridPriceLevel of ladder) {
      openQuantity = new Decimal(totalInvestment).div(gridNumber)
        .div(gridPriceLevel[0])
      if (openQuantity.decimalPlaces() > qtyPrecision || qtyPrecision === 0) {
        openQuantity = new Decimal(floorQuantityByScale(openQuantity.toNumber(), qtyPrecision, minQty))
      }
      openNotional = openQuantity.mul(gridPriceLevel[0])
      closeQuantity = openQuantity.mul(qtyRatioFeesDeducted)
      if (closeQuantity.decimalPlaces() > qtyPrecision || qtyPrecision === 0) {
        closeQuantity = new Decimal(floorQuantityByScale(closeQuantity.toNumber(), qtyPrecision, minQty))
      }
      closeNotional = closeQuantity.mul(gridPriceLevel[1])
      closeFee = closeNotional.mul(adjustedFees)
      // const notional = closeNotional.toNumber()
      // const fee = closeFee.toNumber()

      gridProfit = closeNotional.minus(closeFee).minus(openNotional)
      // const profit = gridProfit.toNumber()

      // console.log('isPositiveGridProfit - for loop - gridNo: ' + gridNo + ', totalInvestment: ' + totalInvestment + ', openPrice: ' + gridPriceLevel[0] + ', openQuantity: ' + openQuantity.toNumber() + ', closePrice: ' + gridPriceLevel[1] + ', closeQuantity: ' + closeQuantity.toNumber() + ', gridProfit:' + gridProfit.toNumber())
      if (gridProfit.lessThanOrEqualTo(0)) {
        return false
      }
    }

    return true
  }
  function roundMinInvestment () {
    if (minTotalInvestment.decimalPlaces() > pricePrecision) {
      minTotalInvestment = minTotalInvestment.toDecimalPlaces(pricePrecision, Decimal.ROUND_UP)
    }
  }
  let minTotalInvestment = new Decimal(upperPrice).mul(gridNo)
    .mul(minQty)

  roundMinInvestment()
  const minTotalInvestmentCap = minTotalInvestment.mul(1000) // minTotalInvestment * 10

  while (!isPositiveGridProfit(minTotalInvestment.toNumber(), gridNo)) {
    if (minTotalInvestment.lessThan(minTotalInvestmentCap)) {
      let minTotalInvestmentDelta = minTotalInvestment.mul(totalInvestmentIncrementer).minus(minTotalInvestment)

      // console.log('minTotalInvestmentDelta:', minTotalInvestmentDelta.toNumber())

      if (minTotalInvestmentDelta.lessThan(priceTick)) {
        minTotalInvestmentDelta = new Decimal(priceTick)
      }
      minTotalInvestment = minTotalInvestment.add(minTotalInvestmentDelta)
      roundMinInvestment()
    } else if (gridNo > 2) {
      gridNo -= 1
    } else {
      return [0, gridNo]
    }
  }
  // console.log('total investment:', minTotalInvestment.toNumber(), 'grid number:', gridNo)
  roundMinInvestment()

  return [minTotalInvestment.toNumber(), gridNo]
}

export const getDisplayProfit = (min:string, max:string) => {
  if (min || max) {
    const profitRange = `${min || '-'}% ~ ${max || '-'}%`

    return min === max ? `${min || '-'}%` : profitRange
  }

  return '-%'
}
